module.exports = __webpack_public_path__ + "img/mask-google-play.32ea3059.png";